import ClubItemBase from "./club_item_base";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ClubAddGame extends ClubItemBase {

    onAddRule(){

        this.dispatchEvent("club_add_game",this.itemIndex);
    }

}
